import { render, staticRenderFns } from "./IconSvgTiff.vue?vue&type=template&id=2f28fc3f&scoped=true&"
import script from "./IconSvgTiff.vue?vue&type=script&lang=js&"
export * from "./IconSvgTiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28fc3f",
  null
  
)

export default component.exports